// src/pages/consultor/ConsultorLayout.tsx
import DashboardLayout from '../../layouts/DashboardLayout';
export default function ConsultorLayout() {
  return <DashboardLayout />; // nada más
}
